import { render, staticRenderFns } from "./detail-component-dossier.vue?vue&type=template&id=b940fc76&scoped=true"
import script from "./detail-component-dossier.vue?vue&type=script&lang=ts"
export * from "./detail-component-dossier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b940fc76",
  null
  
)

export default component.exports